import { combineReducers } from 'redux';
import { Map } from 'immutable';
import data from './data/reducer';
import core from './core';

const MIDDLEWARE_INITIAL_STATE = new Map({
    general: new Map({ state: null })
});

function middleware(state = MIDDLEWARE_INITIAL_STATE, action) {
    switch (action.type) {
        case 'TESTBENCH__MIDDLEWARE_SET_CONNEXION_STATE':
            return core.setMiddlewareConnectionState(state, action.state);
    }
    return state;
}
export default combineReducers({
    middleware,
    data
});



// WEBPACK FOOTER //
// ./environments/testbench/reducer.js